import moment from "moment";

export const dateFormatter = (params) =>
  moment(params?.value).format("ddd, Do MMM YYYY");
